<style scoped="scoped">
	*{
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}
  .theWorldBox{
    padding-top:20px;
    width:1440px;
    margin:0 auto;
    height:auto;
  }
  .nowBox{

    width:100%;
    padding:0 5px;
    display: flex;
    align-items:center;
    margin-bottom: 50px;
  }
  .nowBox div{
    margin-right:40px;
    font-size: 18px;
    cursor: pointer;
    color:#6c6c6c;
  }
  .newClassNav{
    display: flex;
    justify-content: center;
  }
  .newClassNav > div{
    padding: 4px 20px;
    margin: 0 20px;
    font-size: 16px;
    border: 1px solid #aaa;
    cursor: pointer;
    border-radius: 4px;
    background-color: #fff;
  }
  .newClassNav > div.active{
    border: 1px solid #F36800;
    font-weight: 600;
    color: #F36800;
  }
  .modelMarket{
    width: 100%;
    height: 1200px;
    margin-top: 20px;
  }
</style>

<template>
	<div class='theWorldBox' :style="{width:nowClass == '模型'?'1600px':'1440px'}">
    <div>开发中，敬请期待</div>
  </div>
</template>

<script>
  import cloudStore from './cloudStore.vue'
  import theWorld from './theWorld.vue'
  import userList from './index.vue'
  import modelMarket from '../components/cloud/modelMarket'
	export default {
		components:{
        cloudStore,
        theWorld,
        userList,
        modelMarket
		},
		props:[],
		data() {
			return {
          nowClass:'板材',
          classList:['板材','五金','设备','模型'],
          supplierIdentity:2,
          now:'总仓',
          navList:['总仓','全国分仓','供应商','用户地图','查找用户']
			}
		},
		computed: {

		},
		mounted() {
      // 初始化的时候，看是否有查询参数，若有，则对now赋值，直接显示对应子页面
      const now = this.$route.query.now;
      if (now) {
        this.now = now;
      }
		},
		methods: {
      changeClass(value){
        if(value == '五金' || value == '设备'){
          this.$message({
            message: '即将上线，敬请期待！',
            type: 'warning',
            duration:1000
          });
          return
        }
        this.nowClass = value

      },
      changeNow(now){
        this.now=now
        if(now == '总仓'){
          this.supplierIdentity =2
          this.$refs.cloudStore.getIdentity(2)
        }else if(now == '全国分仓'){
          this.supplierIdentity =1
          this.$refs.cloudStore.getIdentity(1)
        }else if(now == '供应商'){
          this.supplierIdentity =0
          this.$refs.cloudStore.getIdentity(0)
        }
      }
		}
	}
</script>
